import { cookiesStorage } from '$utils/services/cookiesStorage'

const isCustomer = () => cookiesStorage.getCookie('userGroup').indexOf('Cliente') > -1

const isCallcenter = () => isCustomer() && cookiesStorage.getCookie('userGroup').indexOf('Callcenter') > -1

const isResidenceAdmin = () =>
  isCustomer() && cookiesStorage.getCookie('userGroup').indexOf('AdministradorResidencias') > -1

const isResidenceModerator = () =>
  isCustomer() && cookiesStorage.getCookie('userGroup').indexOf('GestorResidencias') > -1

const isGuest = () => cookiesStorage.getCookie('userGroup').indexOf('Invitado') > -1

const isRecruiter = () => isCustomer() && cookiesStorage.getCookie('userGroup').indexOf('Recruiter') > -1

const isNormalCustomer = () =>
  isCustomer() && !isCallcenter() && !isResidenceAdmin() && !isResidenceModerator() && !isRecruiter()

export const userGroupService = {
  saveUserGroup: group => cookiesStorage.saveCookie('userGroup', group),
  getUserGroup: () => cookiesStorage.getCookie('userGroup'),
  deleteUserGroup: () => cookiesStorage.deleteCookie('userGroup'),
  isCaretaker: () => cookiesStorage.getCookie('userGroup') === 'Cuidador',
  isGuest,
  isCustomer,
  isCallcenter,
  isResidenceAdmin,
  isResidenceModerator,
  isNormalCustomer,
  isRecruiter,
  isAdmin: () => cookiesStorage.getCookie('userGroup') === 'admin',
}



// WEBPACK FOOTER //
// ./src/utils/services/userGroupService.ts